module.exports = __webpack_public_path__ + "img/close1.5b68197e.gif";